module.exports = __webpack_public_path__ + "img/oman_bg.79adb637.jpg";